<p8-settings-page>
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <p8-settings-header [titlePath]="['Commentaires']"></p8-settings-header>
    <button
             mat-raised-button
             (click)="ExportAllComments()"
             matTooltip="Export Excel de toutes les commentaires"
             style="cursor: pointer;">
      <i class="fa fa-file-excel-o fa-2x" aria-hidden="true" ></i>
    </button>
  </div>
  <app-data-table
    [dataSource]="dsComs"
    [extraParams]="extraParams"
    [filterDisplay]="true"
    [placeHolderFilter]="'Rechercher un commentaire'"
    [toolTipFilter]="'Rechercher un commentaire'"
    [flexAction]="5" [flexColumn]="90"
    [pageSize]="10" [pageSizesList]="[5,10,25]"
    [columns]="columns" [actions]="actions"
    [showLoader]="true"
    class="p8-cm_data-table__search-full-width">
  </app-data-table>
</p8-settings-page>

